import store from "@/store";
import request from "@/utils/request";


export async function getMomentContItem(params) {
    console.log("@@ get list : getMomentContItem");
    let result = request.get("/api/moment/momentCont/",{params});
    return result;
}

export async function getMomentContList(params) {
    console.log("@@ get item : getMomentContList");
    let result = request.get(`/api/moment/momentCont/`,{params} );
    return result;
}

export async function saveMomentCont(params) {
    console.log("@@ post save : saveMomentCont");
    let result = request.post(`/api/moment/momentCont/`,[params]);
    return result;
}

export async function deleteMomentCont(contSeq) {
    console.log("@@ delete : deleteMomentCont");
    const params = {contSeq:contSeq};
    const config = {params:params};
    const result = request.delete(`/api/moment/momentCont/`, config);
    return result;
}